import { DialogContent } from '@mui/material';
import { DialogContentProps } from '@mui/material/DialogContent';

function ContentModalBody(props: DialogContentProps) {
  const { children, ...rest } = props;

  return <DialogContent {...rest}>{children}</DialogContent>;
}

export default ContentModalBody;
